"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8421],{

/***/ 8421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70649);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var MaxPerformanceWebSiteCloudServer = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "common",
        "cloudServer"
    ]).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container px-4 py-12 mx-auto lg:py-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "relative z-10 text-3xl font-semibold text-center text-titleColor text-after-shadow-cloud5 lg:text-4xl",
                children: t("cloudServer:maxPerformanceWebSiteCloudServer")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-8 text-textGray",
                dangerouslySetInnerHTML: {
                    __html: t("cloudServer:maxPerformanceWebSiteCloudServerDesc")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid items-center pt-8 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/betweenDifferencesWebHostingCloudServer.png",
                            width: 414,
                            height: 392,
                            alt: t("cloudServer:maxPerformanceWebSiteCloudServer"),
                            title: t("cloudServer:maxPerformanceWebSiteCloudServer")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServer")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pt-4 font-medium text-textGray",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc2")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pt-4 font-medium text-textGray",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc3")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pt-4 font-medium text-textGray",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc4")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pt-4 font-medium text-textGray",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc5")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pt-4 font-medium text-textGray",
                                children: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc6")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-4",
                                        children: "\uD83D\uDE80"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 font-medium text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:betweenDifferencesWebHostingCloudServerDesc7")
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid items-center pt-16 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:advantagesOfCloudSererForHighTrafficSites")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc5")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc6")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-4 mr-2",
                                        children: "\uD83D\uDCC8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:advantagesOfCloudSererForHighTrafficSitesDesc7")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/advantagesOfCloudServer.png",
                            width: 494,
                            height: 502,
                            alt: t("cloudServer:advantagesOfCloudSererForHighTrafficSites"),
                            title: t("cloudServer:advantagesOfCloudSererForHighTrafficSites")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid items-center pt-16 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "order-2 lg:order-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/seoFriendlyHostinngCloudServer.png",
                            width: 428,
                            height: 392,
                            alt: t("cloudServer:seoFriendlyHostinngCloudServer"),
                            title: t("cloudServer:seoFriendlyHostinngCloudServer")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "order-1 lg:order-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:seoFriendlyHostinngCloudServer")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: " text-textGray",
                                dangerouslySetInnerHTML: {
                                    __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:seoFriendlyHostinngCloudServerDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:seoFriendlyHostinngCloudServerDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pt-4 font-medium text-textGray",
                                        children: t("cloudServer:seoFriendlyHostinngCloudServerDesc4")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 font-medium text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc5")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 font-medium text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc6")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pr-2 mt-4",
                                        children: "\uD83D\uDCCC"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:seoFriendlyHostinngCloudServerDesc7")
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "grid items-center pt-16 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "my-4 text-2xl font-bold text-titleColor lg:text-3xl",
                                children: t("cloudServer:powerUpYourWebsiteWithCloudServer")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center pt-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-medium text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center pt-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-medium text-textGray",
                                        children: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center pt-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "font-medium text-textGray",
                                        children: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc3")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center pt-4 space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "p-2 w-[24px] h-[24px] flex items-center justify-center text-white bg-green-500 rounded-full ri-check-line"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-medium text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc4")
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pr-2 mt-4",
                                        children: "\uD83D\uDE80"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 text-textGray",
                                        dangerouslySetInnerHTML: {
                                            __html: t("cloudServer:powerUpYourWebsiteWithCloudServerDesc5")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/powerUpYourWebsiteCloudHosting.png",
                            width: 420,
                            height: 428,
                            alt: t("cloudServer:powerUpYourWebsiteWithCloudServer"),
                            title: t("cloudServer:powerUpYourWebsiteWithCloudServer")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaxPerformanceWebSiteCloudServer);


/***/ })

}]);